module.exports = __webpack_public_path__ + "static/img/software3.8a05ba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/software3.jpg
// module id = Doty
// module chunks = 2